import { useFragment } from "react-relay";

import type { Props as CommentCountProps } from "@voxmedia/duet-ui/components/meta/CommentCount";
import { CskNavCommentCount_feedContentResource$key } from "src/__generated__/relay/CskNavCommentCount_feedContentResource.graphql";
import { CskNavCommentCount_feedContentResource } from "src/components/CskNavCommentCount/CskNavCommentCount.fragments";
import { useCskCommentCount } from "src/hooks/use-csk-comment-count";
import { useCskCommentsLinkUrl } from "src/hooks/use-csk-comments-link-url";
import { useCskCoralStoryId } from "src/hooks/use-csk-coral-story-id";
import { useShowStoryComments } from "src/hooks/use-show-story-comments";

/** Comment-count props for CSK minimal nav, or null when comments are disabled. */
export function useCskNavCommentCountProps(
  feedContentResource: CskNavCommentCount_feedContentResource$key,
): CommentCountProps | null {
  const data = useFragment(
    CskNavCommentCount_feedContentResource,
    feedContentResource,
  );

  const coralId = useCskCoralStoryId({
    chorusId: data.chorusId,
    chorusUuid: data.chorusUuid,
    globalId: data.globalId,
    nodeId: data.id,
  });
  const showComments = useShowStoryComments(data.comments);
  useCskCommentCount(showComments ? coralId : undefined);
  const commentsLinkUrl = useCskCommentsLinkUrl(data.permalink);

  if (!showComments) {
    return null;
  }

  return {
    coralId,
    url: commentsLinkUrl,
    authorName: data.authors[0]?.name ?? "",
    headline: data.title,
    contentType: data.resourceType,
    noText: true,
    variant: "stickyNav",
  };
}
